export enum ConciergeMethod {
  CALENDLY_CONSULTATION = 'calendlyConsultation',
  CHAT = 'chat',
  MESSAGE = 'message',
  PHONE = 'phone',
  SMS = 'sms',
}
